import { type CardBasic, type CardInventoryItem } from "@/types/pvp-card";

export const CARD_MAX_LEVEL = 13;

export const PvpCardCommodity: Record<string, string> = {
  normalDeck: "见习卡包",
  raceDeck: "专家卡包",
  epicDeck: "大师卡包",
  legendDeck: "传说卡包",
  freeDeck: "免费卡包",
  winsDeck: "对决卡包",
  mallCardPack1: "迷途魔袋",
  mallCardPack2: "困笼魔匣",
  mallCardPack3: "魂缚魔罐",
  mallCardPack4: "深渊魔典",
  mallCardPack5: "神陨魔碑",
  mallCardPack6: "万域魔箱",
};

export const CardTypeIcon: Record<CardBasic["type"], string> = {
  building: "🏛️",
  ground: "👾",
  flying: "🦇",
  ghost: "👻",
};

// regular rank activity
export const GameTypeEnum: Record<string, string> = {
  regular: "常规",
  rank: "排位",
  activity: "活动",
};

const COST_NAME = "金币";
function ampByLevel(value = 0, level: number) {
  return Math.round(value * (1 + 0.1 * (level - 1)));
}
export const SpecialFormulas: Record<
  string,
  (this: CardBasic, params: CardBasic["specials"][0][1]) => string
> = {
  selfBleed(params) {
    return `<b class='heat'>失血</b>：自身每秒流失<b class='hp'>${params.rate}%</b>的生命值`;
  },
  createGold(params) {
    return `<b class='heat'>投资</b>：每秒增加<b class='grow'>${params.value}</b>个${COST_NAME}`;
  },
  atkAure(params) {
    return `<b class='heat'>光环</b>：<b class='info'>${params.value}</b>格范围内的友军增加<b class='atk'>${params.multiplier}%</b>的攻击力`;
  },
  dash(params) {
    return `<b class='heat'>冲锋</b>：移动<b class='info'>${params.value}</b>格后开始冲刺，获得<b class='grow'>${params.multiplier}%</b>加成的移动速度并造成等额伤害`;
  },
  dieBoom(params) {
    return `<b class='heat'>自爆</b>：死亡时对<b class='info'>${params.value}</b>格内的敌人造成<b class='hp'>${params.multiplier}%</b>的伤害`;
  },
  dieBoomLightning(params) {
    return `<b class='heat'>雷爆</b>：死亡时对<b class='info'>${params.value}</b>格内的敌人造成<b class='hp'>${params.multiplier}%</b>的伤害并麻痹`;
  },
  dieBoomSlow(params) {
    return `<b class='heat'>冰爆</b>：死亡时对<b class='info'>${params.value}</b>格内的敌人造成<b class='hp'>${params.multiplier}%</b>的伤害并减速<b class='atksp'>${params.rate}%</b>`;
  },
  atkSlow(params) {
    return `<b class='heat'>寒霜</b>：对目标及附近的敌人造成<b class='atksp'>${params.multiplier}%</b>的减速效果`;
  },
  lightning(params) {
    return `<b class='heat'>闪电</b>：对目标及其附近的${params.value}名敌人造成麻痹效果`;
  },
  fission(params) {
    return `<b class='heat'>分裂</b>：死亡后分裂成<b class='info'>${params.value}</b>个，获得<b class='grow'>${params.multiplier}%</b>的生命值和攻击力`;
  },
  heal(params) {
    return `<b class='heat'>治疗</b>：攻击时对附近的友军造成<b class='grow'>${ampByLevel(
      params.value,
      this.level
    )}</b>点治疗`;
  },
  aoe(params) {
    return `<b class='heat'>溅射</b>：对目标附近的敌人造成<b class='hp'>${params.multiplier}%</b>的伤害`;
  },
  evolve(params) {
    return `<b class='heat'>进化</b>：每秒提升<b class="grow">${params.multiplier}%</b>的生命值和伤害，最高成长至<b class='info'>${params.value}层</b>`;
  },
  atkOnce(params) {
    return `<b class='heat'>破釜</b>：造成一次攻击后死亡`;
  },
  overheat(params) {
    return `<b class='heat'>过热</b>：攻击同一个目标时会叠加一层<b class='heat'>过热</b>，每层过热提升<b class="grow">${params.multiplier}%</b>的伤害，最高<b class='info'>${params.value}层</b>`;
  },
  sleep(params) {
    return `<b class='heat'>沉睡</b>：在被打破沉睡之前不会行动`;
  },
  crystal(params) {
    return `<b class='heat'>水晶</b>：携带魔法水晶登场持续<b class='info'>${params.value}</b>秒，拥有魔法水晶时获得<b class='atksp'>200%</b>的攻击速度提升，魔法水晶可以抵挡<b class='grow'>${params.multiplier}%</b>生命值的伤害`;
  },
  ghost(params) {
    return `<b class='heat'>幽置</b>：可以部署在场地的任何位置`;
  },
  magicAoe(params) {
    return `<b class='heat'>爆炸</b>：死亡时对<b class='info'>${params.value}</b>格内的敌人造成伤害`;
  },
  jumpAtk(params) {
    return `<b class='heat'>跃击</b>：瞬间跳向<b class='info'>${params.value}</b>格内的敌人并对其及附近的敌人造成<b class='hp'>${params.multiplier}%</b>的伤害`;
  },
};
